import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "createPropertyWrapper" }
const _hoisted_2 = { class: "createPropertyContent container p-6" }
const _hoisted_3 = { class: "formHolder" }
const _hoisted_4 = { class: "headline3 mb-5 hidden lg:block" }
const _hoisted_5 = { class: "sectionItem mb-4" }
const _hoisted_6 = { class: "label" }
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { class: "sectionItem mb-4" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "value" }
const _hoisted_11 = {
  key: 0,
  class: "geolocationItem mb-4"
}
const _hoisted_12 = { class: "label mb-4" }
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "buttonsHolder" }

import { useStore } from "@/composables/useTypedStore";
import { IonButton, IonButtons, IonContent, IonIcon, IonPage, useIonRouter } from '@ionic/vue';
import { arrowBack } from "ionicons/icons";
import { ComputedRef, Ref, computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
//Endpoints
import CreatePropertyApi from '@/api/CreatePropertyApi';
//Models
import Immobilie from "@/models/immobilie.model";
//Composables
import { useProperties } from "@/composables/Property/useProperties";
//Components
import AButton from '@/components/Base/AButton.vue';
import Toolbar from "@/components/Navigation/Toolbar";
import AppInput from '@/components/v2/App/AppInput.vue';
import AppMap from '@/components/v2/App/AppMap.vue';
//Helpers
import { usePhotoRecording } from "@/composables/usePhotoRecording";
import useUser from "@/composables/useUser";
import User from "@/models/user";
import { Map } from "maplibre-gl";

//Variables

export default /*#__PURE__*/_defineComponent({
  __name: 'CreateProperty',
  setup(__props) {

const store = useStore()
const router = useIonRouter()
const isNetworkAvailable = computed(() => store.state.app.networkConnected)
const { t } = useI18n({ useScope: 'global' })
const { openPhotoDialog } = usePhotoRecording();
const { uploadPropertyVorschaubild } = useProperties();
const organisationPrefix: ComputedRef<string> = computed(() => {
    const currentUser: User | null = User.query().first();

    return currentUser ? currentUser.organisationPrefix : "";
});

const body: Ref<any> = ref({
    name: '',
    strasse: '',
    plz: '',
    stadt: '',
    stadtbezirk: '',
    externeObjektNr: '',
    baujahr: '',
    geolocationLat: '',
    geolocationLon: '',
    projects: {
        disconnect: [],
        connect: [
            {
                id: null,
                position: {
                    end: true
                }
            }
        ]
    },
    verwalters: {
        connect: [
        {
                id: null,
            }
        ]
    },
});
const images = ref([] as any)
const currentProject = computed(() => store.state.user.currentUserProject)


//Computed Methods
const isButtonActive = computed(() => {
    let value = false

    if (isNetworkAvailable.value) {
        value = buttonActiveOnline()
    } else {
        value = buttonActiveOffline()
    }

    return value
})

//Lifecycle Hooks
onMounted(() => {
    body.value.projects.connect[0].id = currentProject.value.id;
    body.value.verwalters.connect[0].id = useUser().user.value?.id;
})

//Methods
function buttonActiveOnline() {
    let value = false
    if (body.value.name !== '' && body.value.stadt !== '' && body.value.geolocationLat !== '' && body.value.geolocationLon !== '') {
        value = true
    } else {
        value = false
    }
    return value
}

function buttonActiveOffline() {
    let value = false
    if (body.value.name !== '' && body.value.baujahr !== '') {
        value = true
    } else {
        value = false
    }
    return value
}

function handleMapSearchResult(data: any) {
    body.value.strasse = data.address.road ? data.address.road : ''
    body.value.plz = data.address.postcode ? data.address.postcode : ''
    body.value.stadt = data.address.city ? data.address.city : ''
    body.value.stadtbezirk = data.address.city_district ? data.address.city_district : ''
    body.value.geolocationLat = data.lat
    body.value.geolocationLon = data.lon
}

function clearMapSearchResult() {
    body.value.strasse = ''
    body.value.plz = ''
    body.value.stadt = ''
    body.value.stadtbezirk = ''
    body.value.geolocationLat = ''
    body.value.geolocationLon
}

function onChanged(event: any) {
    if (event.features[0]?.geometry.coordinates) {
        body.value.geolocationLon = event.features[0].geometry.coordinates[0]
        body.value.geolocationLat = event.features[0].geometry.coordinates[1]
    }
}

function onMapLoaded(map: Map) {
    map.resize();
}

async function addPhotos() {
    const uploadLimit = 1;
    const photoRes = await openPhotoDialog(t, uploadLimit, {
        hideFile: true,
    });

    if (photoRes.success && photoRes.data && photoRes.data.length > 0) {
        images.value = photoRes.data
    }
}

function removePhoto(index: number) {
    images.value.splice(index, 1)
}

async function handleCreateProperty() {
    try {
        const response = await CreatePropertyApi.postProperty(body.value)
        if (response.status === 200) {
            if (images.value.length > 0) {
                await uploadPropertyVorschaubild(response.data.data, images.value)
            }

            const immobilieObject = {
                id: response.data.data.id,
                isDownloaded: true,
                ...response.data.data.attributes,
            }

            await Immobilie.dispatch('storeMoverObject', immobilieObject );

            router.navigate(`/property/${immobilieObject.id}`, 'forward', 'pop');

        }
    } catch (err: any) {
        const immobilieObject = {
            id: `0.${Math.floor(Math.random() * 10000000)}`,
            isDownloaded: true,
            hasUnsavedChanges: true,
            vorschaubild: images.value,
            ...body.value
        }
        await Immobilie.dispatch('storeMoverObject', immobilieObject );

        router.navigate('/properties', 'forward', 'pop')
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(Toolbar), {
        title: _unref(t)(`${organisationPrefix.value}toolbar.mobile.createObject`)
      }, {
        leading: _withCtx(() => [
          _createVNode(_unref(IonButtons), { slot: "start" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButton), {
                fill: "clear",
                class: "px-0 -ml-4",
                size: "small",
                onClick: _cache[0] || (_cache[0] = () => _unref(router).back())
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    icon: _unref(arrowBack),
                    size: "large",
                    class: "whiteColor"
                  }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(IonContent), null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)(`${organisationPrefix.value}createProperty.createObject`)), 1),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('createProperty.city')), 1),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(AppInput, {
                      modelValue: body.value.stadt,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((body.value.stadt) = $event)),
                      placeholder: _unref(t)('createProperty.typeLabel')
                    }, null, 8, ["modelValue", "placeholder"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('createProperty.name')) + "* ", 1),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(AppInput, {
                      modelValue: body.value.name,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((body.value.name) = $event)),
                      placeholder: _unref(t)('createProperty.typeLabel')
                    }, null, 8, ["modelValue", "placeholder"])
                  ])
                ]),
                (isNetworkAvailable.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(t)('createProperty.geoLocation')) + "* ", 1),
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(AppMap, {
                          identifier: 'objectLocation',
                          "map-settings": currentProject.value.mapConfig?.createPropertyMap,
                          "allow-only-one-drawing": true,
                          "onUpdate:inputJson": onChanged,
                          "onUpdate:mapSearch": handleMapSearchResult,
                          "onUpdate:clearMapSearchInputs": clearMapSearchResult,
                          "onMap:loaded": _cache[3] || (_cache[3] = ($event: any) => (onMapLoaded($event)))
                        }, null, 8, ["map-settings"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(AButton, {
                  disabled: isButtonActive.value ? false : true,
                  "btn-primary": true,
                  class: "px-16 py-6 text-lg",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (handleCreateProperty()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('createProperty.submit')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(AButton, {
                  "btn-secondary": true,
                  class: "px-16 py-6 text-lg",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(router).back()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('createProperty.cancel')), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})